import {appContainer} from "../contexts/app";
import {deleteInState, fromImmutable, setInState, setListInState, toImmutable, validate} from "./hooks";
import BuildingRecordFactory from "./building-record";

export default app => {
  const service = app.service("api/buildings");

  const BuildingRecord = BuildingRecordFactory(service);
  appContainer.BuildingRecord = BuildingRecord;
  app.set("BuildingRecord", BuildingRecord);

  const validateBuilding = validate({
    name: "Building name is required."
  });

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateBuilding],
      update: [fromImmutable, validateBuilding],
      patch: [fromImmutable, validateBuilding],
      remove: []
    },

    after: {
      all: [toImmutable(BuildingRecord)],
      find: [setListInState("buildings")],
      get: [setInState("buildings")],
      create: [setInState("buildings")],
      update: [setInState("buildings")],
      patch: [setInState("buildings")],
      remove: [deleteInState("buildings")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/buildings.js